<ng-container *ngIf="backRoute || defaultBackRoute">
    <div [ngClass]="{ 'ms-u-hiddenMdDown' : responsive }"
         class="back-button">
        <ohp-icon-font [id]="elementId"
            cssClass="back-button__icon ms-fcl-tp"
            iconFontName="ArrowLeft"
            iconButton="true"
            ariaVisible="true"
            [ariaLabel]= "backButtonAriaLabel || defaultAriaLabel"
            dataArea="Hero"
            dataNav=1
            (iconClicked)="navigateBack()"
            [title]="backButtonAriaLabel || defaultAriaLabel"
            [focusOnLoad]="focusOnLoad">
        </ohp-icon-font>
    </div>
</ng-container>
